export type SpecificallyAuditDataItemValues = {
  key: string;
  value?: string;
};
